import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Default workflow set ID.
 */
export const schema = z.number().int().positive();

export type DefaultWorkflowSetId = z.infer<typeof schema>;

export const definition = define({
  key: 'default_workflow_set_id',
  schema,
  label: 'Default Workflow Set',
  description:
    'The default workflow set is the preferred set of pickup and delivery workflows used for clients at this level.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 1,
});
